// extracted by mini-css-extract-plugin
export var quillEditor = "_ml-1";
export var variable = "_ml-0";